module.exports = __webpack_public_path__ + "static/media/ic_template_13.b0d77da8.png";